export const MemeOne = [
    {   
        type: 1,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image2.png',
    },
    {   
        type: 1,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image9.png',
    },
    {   
        type: 1,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image13.png',
    },
]
    


export const MemeTwo = [
    {   
        type: 2,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image11.png',
    },
    // {   
    //     type: 2,
    //     url: 'https://static.igem.wiki/teams/4241/wiki/memes/image10.png',
    // },
    {   
        type: 2,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image4.png',
    },
    {   
        type: 2,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image6.png',
    },
    // {   
    //     type: 2,
    //     url: 'https://static.igem.wiki/teams/4241/wiki/memes/image15.png',
    // },
]

export const MemeThree = [
    {   
        type: 3,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image8.png',
    },
    {   
        type: 3,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image5.png',
    },
    {   
        type: 3,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image3.png',
    },
    {   
        type: 3,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image1.png',
    },
]

export const MemeFour = [
    {   
        type: 4,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image16.png',
    },
    {   
        type: 4,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image14.png',
    },
    {   
        type: 4,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image12.png',
    },
    {   
        type: 4,
        url: 'https://static.igem.wiki/teams/4241/wiki/memes/image7.png',
    },
]